"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var OrganizationItem_styles_1 = __importDefault(require("./OrganizationItem.styles"));
function OrganizationItem(_a) {
    var href = _a.href, title = _a.title;
    return (react_1.default.createElement(OrganizationItem_styles_1.default, { "data-sri-anchor": "org-switcher.organization-item", href: href, "data-testid": "organization-link" }, title));
}
exports.default = OrganizationItem;
OrganizationItem.propTypes = {
    href: prop_types_1.default.string.isRequired,
    title: prop_types_1.default.string.isRequired,
};
//# sourceMappingURL=OrganizationItem.js.map